import Page from './page';
import FacetFilters from '../components/product/facet-filters';

export default class CategoryPage extends Page {
  private readonly tireFacetFilters: FacetFilters;

  constructor(protected body: JQuery) {
    super();

    this.tireFacetFilters = new FacetFilters(body.find('.js-facetForm'));
  }
}
